import React from "react";

import ArticleCard from "../ArticleCard";

export function buildArticleCard(story) {
  return (
    <div className="grid-item">
      <ArticleCard
        headline={story.title.rendered}
        excerpt={story.excerpt.rendered}
        href={story.link}
        as={story.link}
        // TODO: format date
        date={new Date(story.date)}
        authors={[
          {
            name: story._embedded.author[0].name,
            href: story._embedded.author[0].link,
            as: story._embedded.author[0].link
          }
        ]}
        category={{
          name: story._embedded["wp:term"][0][0].name,
          href: story._embedded["wp:term"][0][0].link,
          as: story._embedded["wp:term"][0][0].link
        }}
        imageurl={
          story._embedded["wp:featuredmedia"] != undefined &&
          !story._embedded["wp:featuredmedia"].empty
            ? story._embedded["wp:featuredmedia"][0].source_url
            : ""
        }
        caption={
          story._embedded["wp:featuredmedia"] != undefined &&
          !story._embedded["wp:featuredmedia"].empty
            ? story._embedded["wp:featuredmedia"][0].caption.rendered
            : ""
        }
      />
    </div>
  );
}

export function buildArticleCards(stories) {
  var i;
  let postArray = [];
  for (i = 0; i < stories.length; i++) {
    postArray.push(buildArticleCard(stories[i]));
  }
  return postArray;
}
